<template>
  <a-layout id="components-layout-demo-top" class="layout">
    <a-layout-header style="background: #fff;box-shadow: 0 2px 8px #f0f1f2;position: relative;z-index: 10;max-width: 100%;">
    <a-row type="flex" justify="center">
    <a-col :xs="2" :sm="4" :md="6" :lg="8" :xl="10"></a-col>
    <a-col :xs="20" :sm="16" :md="12" :lg="8" :xl="4">
      <a-row type="flex" justify="center" @click="push('dashboard')">
        <a-col :span="12"><div class="logo" @click="push('dashboard')"><img src="https://auction.joyland.top/icon-left-font.png" style="width:80%"></div></a-col>
        <a-col :span="12"><div class="logo"  @click="push('dashboard')"><a-icon type="yuque"/> Auction</div></a-col>
      </a-row>
    </a-col>
    <a-col :xs="2" :sm="4" :md="6" :lg="8" :xl="10"></a-col>
    </a-row>
    </a-layout-header>
    <a-layout-content style="padding: 0 15px;padding-top:15px">
      <div :style="{ background: '#fafafa', padding: '24px', minHeight: '280px' }">
      <router-view />
      </div>
    </a-layout-content>
    <a-layout-footer style="text-align: center">
      JOYland-Auction ©2026 by JOYland
    </a-layout-footer>
  </a-layout>
</template>
<style>
#components-layout-demo-top {
  background-color: transparent;
}
#components-layout-demo-top .logo {
  width: 120px;
  height: 31px;
  float: left;
  font-size: 18px;
}
</style>

<script>

export default {
  name: 'app',
  data () {
    return {
      collapsed: false
    }
  },
  mounted () {
  },
  methods: {
    push (name) {
      this.$router.push('/' + name)
    }
  }
}
</script>
